/**
 * HE-P04 — Purchase Orders enabled for this workspace/tenant.
 *
 * TODO (confirm against HE-P04 spec before shipping):
 *   1. Replace this constant with the real workspace/tenant flag once it exists
 *      (likely a config endpoint or env like REACT_APP_HE_PO_ENABLED).
 *   2. Confirm chooser behaviour when POs are off: hide the "By Purchase Order"
 *      card, or show it disabled with a tooltip. Flip
 *      {@link PO_DISABLED_CHOOSER_BEHAVIOR} — one line either way.
 *
 * Defaults: POs ON. The chooser loads ACTIVE purchase orders from
 * `purchaseOrderService` (Module A). When off, the card is shown disabled
 * (discoverable) rather than hidden.
 */
export const PO_ENABLED = true;

/** What HE-F02 does with the PO card when {@link PO_ENABLED} is false. */
export type PoDisabledChooserBehavior = 'hide' | 'disable';

export const PO_DISABLED_CHOOSER_BEHAVIOR: PoDisabledChooserBehavior = 'disable';

export const PO_DISABLED_TOOLTIP =
  "Purchase orders aren't enabled for this workspace. Choose By Subcontractor or By Task, or enter lines manually.";
